//#region imports
import { ContactInformationDialogComponent } from './../dialogs/contact-information-dialog/contact-information-dialog.component';
import { SupportDialogComponent } from './../dialogs/support-dialog/support-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { Component, OnInit, Input, ComponentFactoryResolver } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from 'src/app/services/globals';
import { GuaranteeService } from 'src/app/services/guarantee.service';
import { CharacteristicService } from 'src/app/services/characteristic.service';
//#endregion

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  //#region variables
  @Input() defaultLanguage;
  @Input() federaleURL;
  logoPath = 'assets/icons/logo.svg';
  selectLanguage : boolean;
  General_Header_Marketing;
  selectedLanguage;
  //#endregion

  //#region methods
  constructor(
    public translate: TranslateService, private globals: Globals,
    private characteristicService: CharacteristicService,
    private guaranteeService: GuaranteeService, private matDialog: MatDialog) { }

  ngOnInit() {
    this.characteristicService.getDefaultLanguage().subscribe((value) => {
      this.defaultLanguage = value;
      if(value === 'NL'){
        this.logoPath = 'assets/icons/logo-NL.svg';
        console.log(this.logoPath);
        this.General_Header_Marketing = this.translate.instant('General_Header_Marketing_Text');
        this.selectLanguage = true;
      }
      else{
        this.logoPath = 'assets/icons/logo.svg';
        console.log(this.logoPath);
        this.General_Header_Marketing = this.translate.instant('General_Header_Marketing_Text');
        this.selectLanguage = false;
      }
      // this.changeLanguage();
    });

    this.characteristicService.getFederaleURL().subscribe((value) => {
      this.federaleURL = value;
    });
    
    // setTimeout (() => {
    //   this.changeLanguage_refresh(), 5000});
      console.log('head54' + this.globals.languagecode)
  }

  changeLanguage(){
    this.selectLanguage = !this.selectLanguage;
    if( this.selectLanguage == true){
      this.defaultLanguage = "NL";
    }else{
      this.defaultLanguage = "FR";
    }
    this.switchLang(this.defaultLanguage);
    console.log(this.defaultLanguage);
  }

  //The below function uses for page refreshing purpose only
  changeLanguage_refresh(){
    // this.selectLanguage = !this.selectLanguage;
    if( this.selectLanguage == true){
      this.defaultLanguage = "NL";
    }else{
      this.defaultLanguage = "FR";
    }
    this.switchLang(this.defaultLanguage);
    console.log('head65' + this.defaultLanguage);
  }


  switchLang(lang: string) {
    this.translate.use(lang);
    console.log('head70' + lang);
    this.characteristicService.setDefaultLanguage(lang);
    this.guaranteeService.setLanguage(lang);
    this.globals.languagecode = lang;
    this.globals.filteredLocation = [];
    this.globals.filteredCountry = [];
    sessionStorage.setItem('language',lang);
    setTimeout(() => { this.setPaymentFrequency(); }, 2000);
    if (this.globals.languagecode === 'FR' && this.globals.postalCode !== undefined && this.globals.postalCode !== null &&
      this.globals.postalCode !== '' && this.globals.postalCode.length === 4) {
      const location = this.globals.locationData.Locations.filter(obj => obj.PostalCode === this.globals.postalCode);
      if (location != null) {
        location.forEach(obj => this.globals.filteredLocation.push(obj.LibelleFR));
      }
    } else if (this.globals.languagecode === 'NL' && this.globals.postalCode !== undefined && this.globals.postalCode != null &&
      this.globals.postalCode !== '' && this.globals.postalCode.length === 4) {
      const location = this.globals.locationData.Locations.filter(obj => obj.PostalCode === this.globals.postalCode);
      if (location != null) {
        location.forEach(obj => this.globals.filteredLocation.push(obj.LibelleNL));
      }
    }
    if (this.globals.countryData != null) { this.setCountry(); }
    
    if(lang === 'NL'){
      this.logoPath = 'assets/icons/logo-NL.svg';
      console.log(this.logoPath);
      this.selectLanguage = true;
    }
    else{
      this.logoPath = 'assets/icons/logo.svg';
      console.log(this.logoPath);
      this.selectLanguage = false;
    }
  }

  setCountry() {
    if (this.globals.languagecode === 'FR') {
      this.globals.countryData.Countries.forEach(obj => this.globals.filteredCountry.push(obj.NomPaysFR));
      this.globals.filteredCountry.sort();
      this.globals.selectedCountry = 'BELGIQUE';
    } else if (this.globals.languagecode === 'NL') {
      this.globals.countryData.Countries.forEach(obj => this.globals.filteredCountry.push(obj.NomPaysNL));
      this.globals.filteredCountry.sort();
      this.globals.selectedCountry = 'BELGIE';
    } else {
      this.globals.countryData.Countries.forEach(obj => this.globals.filteredCountry.push(obj.NomPaysEN));
      this.globals.filteredCountry.sort();
      this.globals.selectedCountry = 'BELGIEN';
    }
  }

  setPaymentFrequency() {
    const premiumFrequency1 = this.translate.instant('Tab_Frequency_Payment1');
    const premiumFrequency2 = this.translate.instant('Tab_Frequency_Payment2');
    const premiumFrequency3 = this.translate.instant('Tab_Frequency_Payment3');
    const premiumSplitFrequency1 = this.translate.instant('Tab_Frequency_SplitPayment1');
    const premiumSplitFrequency2 = this.translate.instant('Tab_Frequency_SplitPayment2');
    const premiumSplitFrequency3 = this.translate.instant('Tab_Frequency_SplitPayment3');
    
    this.globals.paymentFrequency = [{Frequency :premiumFrequency1, Percentage : ' ' }, 
      {Frequency :premiumFrequency2, Percentage : premiumSplitFrequency2 }, 
      {Frequency :premiumFrequency3, Percentage : premiumSplitFrequency3 }];
  }

  supportDialog() {
    // const today = new Date();
    this.characteristicService.getServerTime().subscribe((today)=>{
    const day = new Date(today).getDay(); //  Number.parseInt(today.substr(8,2));
    const time = Number.parseInt(today.substr(11,2));
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    if ((time >= 9 && time <= 16) && (day > 0 && day < 6)) {
      this.matDialog.open(SupportDialogComponent, dialogConfig);
    } else {
      this.matDialog.open(ContactInformationDialogComponent, dialogConfig);
    }
  }
  )}
  //#endregion
}
